export default __webpack_public_path__ + "static/img/27.edfd78f.png";